import { AppState } from '../../types';
import { UnnamedSegmentRecord } from './types';

export const getUnnamedSegmentById = (
  state: AppState,
  id: string,
): UnnamedSegmentRecord | undefined => state.unnamedSegments.unnamedSegmentsById[id];

export const getUnnamedSegmentIdByHash = (state: AppState, hash: number): string | undefined =>
  state.unnamedSegments.unnamedSegmentIdsByHash[hash];

export const makeUnnamedSegmentByIdHash =
  (hash: number) =>
  (state: AppState): string | undefined =>
    state.unnamedSegments.unnamedSegmentIdsByHash[hash];
